module.exports = __webpack_public_path__ + "static/00018.ff189a44.jpg";